export const MultiVillagePicker = ({ villages, value, onChange }) => {
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  return (
    <div className="mt-4" data-testid="multi-village-picker">
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-xs font-semibold text-slate-600" data-testid="multi-village-count">{value.length} köy seçildi</span>
        <div className="flex gap-3 text-xs">
          <button type="button" className="text-emerald-700 hover:underline" onClick={() => onChange(villages.map((v) => v.id))}
                  data-testid="multi-village-select-all">Tümünü seç</button>
          <button type="button" className="text-slate-500 hover:underline" onClick={() => onChange([])}
                  data-testid="multi-village-clear">Temizle</button>
        </div>
      </div>
      <div className="max-h-44 overflow-y-auto rounded-md border border-slate-200 bg-slate-50 p-2 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
        {villages.length === 0 && <span className="text-xs text-slate-400">Köy bulunmuyor</span>}
        {villages.map((v) => (
          <label key={v.id} className="inline-flex items-center gap-1.5 text-sm text-slate-700 cursor-pointer select-none min-w-0">
            <input type="checkbox" className="h-4 w-4 accent-emerald-700 shrink-0" checked={value.includes(v.id)}
                   onChange={() => toggle(v.id)} data-testid={`multi-village-option-${v.id}`} />
            <span className="truncate">{v.name}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export const CheckOption = ({ checked, onChange, label, testId }) => (
  <label className="mt-3 flex items-center gap-2 text-sm text-slate-700 cursor-pointer select-none">
    <input type="checkbox" className="h-4 w-4 accent-emerald-700" checked={checked} onChange={(e) => onChange(e.target.checked)} data-testid={testId} />
    {label}
  </label>
);
